(function () {
  function query(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function queryAll(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function parseConfig(root) {
    var el = query(root, '[data-memorial-wizard-v7-config]');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error('Memorial wizard v7 config parse error', error);
      return null;
    }
  }

  function getLabel(config, key, fallback) {
    if (config && config.labels && config.labels[key]) {
      return config.labels[key];
    }
    return fallback;
  }

  function findMedia(config, mediaId) {
    if (!config || !config.media || !mediaId) return null;

    return config.media.find(function (media) {
      return String(media.id) === String(mediaId);
    }) || null;
  }

  function requestVideoPlay(video) {
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('muted', 'muted');
    video.setAttribute('autoplay', 'autoplay');
    video.setAttribute('loop', 'loop');
    video.setAttribute('playsinline', 'playsinline');
    video.setAttribute('webkit-playsinline', 'webkit-playsinline');
    video.controls = false;
    video.removeAttribute('controls');

    function attemptPlay() {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    if (!video.__mw5AutoplayBound) {
      ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'].forEach(function (eventName) {
        video.addEventListener(eventName, attemptPlay);
      });
      video.__mw5AutoplayBound = true;
    }

    attemptPlay();
    window.setTimeout(attemptPlay, 120);
    window.setTimeout(attemptPlay, 500);
    window.setTimeout(attemptPlay, 1200);
  }

  function visibleRatioInGallery(item, gallery) {
    if (!item || !gallery || typeof item.getBoundingClientRect !== 'function' || typeof gallery.getBoundingClientRect !== 'function') {
      return 0;
    }

    var itemRect = item.getBoundingClientRect();
    var galleryRect = gallery.getBoundingClientRect();
    var overlapLeft = Math.max(itemRect.left, galleryRect.left);
    var overlapRight = Math.min(itemRect.right, galleryRect.right);
    var overlapWidth = Math.max(0, overlapRight - overlapLeft);

    if (!itemRect.width) return 0;

    return overlapWidth / itemRect.width;
  }

  function syncGalleryVideoPlayback(root) {
    var gallery = query(root, '[data-gallery]');

    queryAll(root, '[data-gallery-media-id]').forEach(function (item) {
      var video = query(item, 'video');
      if (!video) return;

      var isActive = item.classList.contains('is-active');
      var visibleRatio = visibleRatioInGallery(item, gallery);
      var shouldPlay = isActive || visibleRatio > 0.55;

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('muted', 'muted');
      video.setAttribute('autoplay', 'autoplay');
      video.setAttribute('loop', 'loop');
      video.setAttribute('playsinline', 'playsinline');
      video.setAttribute('webkit-playsinline', 'webkit-playsinline');
      video.controls = false;
      video.removeAttribute('controls');
      video.setAttribute('preload', 'metadata');

      if (shouldPlay) {
        if (!video.readyState) {
          try { video.load(); } catch (e) {}
        }
        requestVideoPlay(video);
      } else {
        try { video.pause(); } catch (e) {}
      }
    });
  }

  function setActiveMedia(root, mediaId) {
    var currentActive = query(root, '[data-gallery-media-id].is-active');
    if (currentActive && mediaId && String(currentActive.getAttribute('data-gallery-media-id')) === String(mediaId)) {
      syncGalleryVideoPlayback(root);
      return;
    }

    var activeItem = null;

    queryAll(root, '[data-gallery-media-id]').forEach(function (item) {
      var isActive = mediaId && String(item.getAttribute('data-gallery-media-id')) === String(mediaId);
      item.classList.toggle('is-active', Boolean(isActive));
      if (isActive) activeItem = item;
    });

    syncGalleryVideoPlayback(root);

    // scroll disabled intentionally
  }

  function stepCount(root) {
    return Math.max(queryAll(root, '[data-step-panel]').length, 1);
  }

  function setProgress(root, stepIndex) {
    var totalSteps = stepCount(root);

    queryAll(root, '[data-go-step]').forEach(function (button) {
      var buttonIndex = Number(button.getAttribute('data-go-step'));
      button.classList.toggle('is-active', buttonIndex === stepIndex);
      button.classList.toggle('is-complete', buttonIndex < stepIndex);
    });

    queryAll(root, '[data-step-panel]').forEach(function (panel) {
      var panelIndex = Number(panel.getAttribute('data-step-panel'));
      var isActive = panelIndex === stepIndex;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    var fill = query(root, '[data-progress-fill]');
    if (fill) {
      fill.style.width = ((stepIndex + 1) / totalSteps) * 100 + '%';
    }
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        var native = window.Shopify.formatMoney(cents, fmt);
        if (native) return native;
      } catch (e) {}
    }

    var dollars = Number(cents || 0) / 100;
    var amount = dollars.toFixed(2);
    var amountWhole = Math.round(dollars).toString();
    var amountComma = amount.replace('.', ',');

    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountWhole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountWhole);
  }

  function readSelectedState(root) {
    var state = {
      byName: {},
      byPosition: {}
    };

    var stepper = query(root, '[data-people-stepper]');
    if (stepper) {
      var peopleName = stepper.getAttribute('data-option-name');
      var peoplePosition = stepper.getAttribute('data-option-position');
      var peopleValue = stepper.getAttribute('data-selected-option-value') || '';
      var peopleValueId = stepper.getAttribute('data-selected-option-value-id') || '';

      if (peopleName) {
        state.byName[peopleName] = peopleValue;
      }

      if (peoplePosition && peopleValueId) {
        state.byPosition[String(peoplePosition)] = String(peopleValueId);
      }
    }

    queryAll(root, '[data-option-name][data-option-value-id].is-selected').forEach(function (button) {
      var optionName = button.getAttribute('data-option-name');
      var optionValue = button.getAttribute('data-option-value') || '';
      var optionPosition = button.getAttribute('data-option-position');
      var optionValueId = button.getAttribute('data-option-value-id') || '';

      if (optionName) {
        state.byName[optionName] = optionValue;
      }

      if (optionPosition && optionValueId) {
        state.byPosition[String(optionPosition)] = String(optionValueId);
      }
    });

    return state;
  }

  function selectedOptionValueIds(state) {
    return Object.keys(state.byPosition)
      .sort(function (left, right) {
        return Number(left) - Number(right);
      })
      .map(function (position) {
        return state.byPosition[position];
      })
      .filter(Boolean);
  }

  function updateSummary(root, state, config) {
    var peopleEl = query(root, '[data-summary-people]');
    var sizeEl = query(root, '[data-summary-size]');
    var frameEl = query(root, '[data-summary-frame]');

    if (peopleEl) {
      peopleEl.textContent = config.peopleOptionName ? (state.byName[config.peopleOptionName] || '') : '';
    }

    if (sizeEl) {
      sizeEl.textContent = config.sizeOptionName ? (state.byName[config.sizeOptionName] || '') : '';
    }

    if (frameEl) {
      frameEl.textContent = config.frameOptionName ? (state.byName[config.frameOptionName] || '') : '';
    }
  }

  function updateSummaryImage(root, config, mediaId) {
    var image = query(root, '[data-summary-image]');
    if (!image) return;

    var media = findMedia(config, mediaId);
    if (!media) return;

    image.src = media.src;
    image.alt = media.alt || image.alt || '';
  }

  function updateArtistUpsell(root, config, selectedVariant) {
    var artist = config.artist;
    var checkbox = query(root, '[data-artist-upsell-checkbox]');
    var row = query(root, '[data-summary-artist-row]');
    var valueEl = query(root, '[data-summary-artist]');
    var reviewPrice = query(root, '[data-wizard-price-review]');
    var reviewCompare = query(root, '[data-wizard-compare-review]');
    var reviewSave = query(root, '[data-wizard-save-review]');

    if (!checkbox || !artist || !artist.variantId || !selectedVariant) {
      if (row) row.classList.add('is-hidden');
      return;
    }

    var totalPrice = Number(selectedVariant.price || 0);
    var totalCompare = Number(selectedVariant.compareAtPrice || 0);

    if (checkbox.checked) {
      totalPrice += Number(artist.price || 0);
      totalCompare += Number(artist.compareAtPrice || artist.price || 0);

      if (row) row.classList.remove('is-hidden');
      if (valueEl) {
        valueEl.textContent = artist.summaryTitle || artist.title || 'Top-rated artist';
      }
    } else {
      if (row) row.classList.add('is-hidden');
      totalCompare = Number(selectedVariant.compareAtPrice || 0);
    }

    if (reviewPrice) {
      reviewPrice.textContent = formatMoney(totalPrice, config.moneyFormat);
    }

    if (reviewCompare) {
      if (totalCompare > totalPrice) {
        reviewCompare.textContent = formatMoney(totalCompare, config.moneyFormat);
        reviewCompare.classList.remove('is-hidden');
      } else {
        reviewCompare.textContent = '';
        reviewCompare.classList.add('is-hidden');
      }
    }

    if (reviewSave) {
      if (totalCompare > totalPrice) {
        var percent = Math.round(((totalCompare - totalPrice) / totalCompare) * 100);
        reviewSave.textContent = '-' + percent + '%';
        reviewSave.classList.remove('is-hidden');
      } else {
        reviewSave.textContent = '';
        reviewSave.classList.add('is-hidden');
      }
    }
  }

  function updatePeopleStepper(root, config) {
    var stepper = query(root, '[data-people-stepper]');
    if (!stepper || !config.peopleValues || !config.peopleValues.length) return;

    var values = config.peopleValues.slice();
    var currentValueId = String(stepper.getAttribute('data-selected-option-value-id') || '');
    var currentValue = stepper.getAttribute('data-selected-option-value') || '';
    var currentIndex = values.findIndex(function (value) {
      return String(value.id) === currentValueId;
    });

    if (currentIndex < 0) {
      currentIndex = values.findIndex(function (value) {
        return value && value.selected;
      });
    }

    if (currentIndex < 0) {
      currentIndex = 0;
    }

    if (values[currentIndex]) {
      currentValueId = String(values[currentIndex].id);
      currentValue = values[currentIndex].name || currentValue || '';
      stepper.setAttribute('data-selected-option-value-id', currentValueId);
      stepper.setAttribute('data-selected-option-value', currentValue);
    }

    var valueEl = query(stepper, '[data-stepper-current]');
    var prevButton = query(stepper, '[data-stepper-dir="-1"]');
    var nextButton = query(stepper, '[data-stepper-dir="1"]');

    if (valueEl) {
      valueEl.textContent = currentValue;
    }

    function applyButtonState(button, candidate) {
      if (!button) return;

      if (candidate) {
        button.disabled = false;
        button.setAttribute('data-stepper-target-value', candidate.name || '');
        button.setAttribute('data-stepper-target-value-id', candidate.id || '');
        button.setAttribute('data-product-url', candidate.productUrl || root.getAttribute('data-product-url') || '');
      } else {
        button.disabled = true;
        button.setAttribute('data-stepper-target-value', '');
        button.setAttribute('data-stepper-target-value-id', '');
        button.setAttribute('data-product-url', '');
      }
    }

    function findAdjacent(direction) {
      var index = currentIndex + direction;

      while (index >= 0 && index < values.length) {
        var candidate = values[index];

        if (candidate && (candidate.available || String(candidate.id) === currentValueId)) {
          return candidate;
        }

        index += direction;
      }

      return null;
    }

    applyButtonState(prevButton, findAdjacent(-1));
    applyButtonState(nextButton, findAdjacent(1));
  }

  function updateVariantDisplay(root, config) {
    var selectedVariant = config.currentVariant || null;
    var variantIdInput = query(root, '[data-variant-id-input]');
    var priceEls = queryAll(root, '[data-wizard-price], [data-wizard-price-review]');
    var compareEls = queryAll(root, '[data-wizard-compare], [data-wizard-compare-review]');
    var saveEls = queryAll(root, '[data-wizard-save], [data-wizard-save-review]');
    var statusEl = query(root, '[data-wizard-status]');
    var submitButton = query(root, '[data-submit]');
    var submitLabel = query(root, '[data-submit-label]');

    if (selectedVariant) {
      if (variantIdInput) {
        variantIdInput.value = selectedVariant.id || '';
      }

      priceEls.forEach(function (el) {
        el.textContent = selectedVariant.priceMoney || '';
      });

      compareEls.forEach(function (el) {
        if (selectedVariant.compareAtMoney && selectedVariant.compareAtMoney !== selectedVariant.priceMoney) {
          el.textContent = selectedVariant.compareAtMoney;
          el.classList.remove('is-hidden');
        } else {
          el.textContent = '';
          el.classList.add('is-hidden');
        }
      });

      saveEls.forEach(function (el) {
        if (selectedVariant.compareAtPrice && selectedVariant.compareAtPrice > selectedVariant.price) {
          var percent = Math.round(((selectedVariant.compareAtPrice - selectedVariant.price) / selectedVariant.compareAtPrice) * 100);
          el.textContent = '-' + percent + '%';
          el.classList.remove('is-hidden');
        } else {
          el.textContent = '';
          el.classList.add('is-hidden');
        }
      });

      if (submitButton) {
        submitButton.disabled = !selectedVariant.available;
      }

      if (submitLabel) {
        submitLabel.textContent = selectedVariant.available
          ? getLabel(config, 'addToCart', 'Add to cart')
          : getLabel(config, 'soldOut', 'Sold out');
      }

      if (statusEl) {
        statusEl.textContent = selectedVariant.available ? '' : 'This combination is currently sold out.';
      }

      if (selectedVariant.featuredMediaId) {
        setActiveMedia(root, selectedVariant.featuredMediaId);
        updateSummaryImage(root, config, selectedVariant.featuredMediaId);
      } else {
        syncGalleryVideoPlayback(root);
      }
    } else {
      if (variantIdInput) {
        variantIdInput.value = '';
      }

      priceEls.forEach(function (el) {
        el.textContent = '';
      });

      compareEls.forEach(function (el) {
        el.textContent = '';
        el.classList.add('is-hidden');
      });

      saveEls.forEach(function (el) {
        el.textContent = '';
        el.classList.add('is-hidden');
      });

      if (submitButton) {
        submitButton.disabled = true;
      }

      if (submitLabel) {
        submitLabel.textContent = getLabel(config, 'unavailable', 'Unavailable');
      }

      if (statusEl) {
        statusEl.textContent = 'This option combination is unavailable. Please pick another combination.';
      }

      syncGalleryVideoPlayback(root);
    }

    updateArtistUpsell(root, config, selectedVariant);
    return selectedVariant;
  }

  function buildSelectionCacheKey(productUrl, optionValueIds) {
    return [productUrl || '', optionValueIds && optionValueIds.length ? optionValueIds.join(',') : ''].join('::');
  }

  function applyOptimisticSelection(root, config, selection) {
    if (!selection || !selection.optionPosition || !selection.optionValueId) return;

    var position = String(selection.optionPosition);

    queryAll(root, '[data-option-position="' + position + '"][data-option-value-id]').forEach(function (button) {
      var isSelected = String(button.getAttribute('data-option-value-id')) === String(selection.optionValueId);
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    var stepper = query(root, '[data-people-stepper]');
    if (stepper && String(stepper.getAttribute('data-option-position')) === position) {
      stepper.setAttribute('data-selected-option-value-id', String(selection.optionValueId));
      stepper.setAttribute('data-selected-option-value', selection.optionValueName || '');

      var currentValue = query(stepper, '[data-stepper-current]');
      if (currentValue) {
        currentValue.textContent = selection.optionValueName || '';
      }

      updatePeopleStepper(root, config);
    }

    var state = readSelectedState(root);
    if (selection.optionName) {
      state.byName[selection.optionName] = selection.optionValueName || '';
    }
    state.byPosition[position] = String(selection.optionValueId);
    updateSummary(root, state, config);
  }

  function buildSectionUrl(productUrl, sectionId, optionValueIds) {
    var url = new URL(productUrl || window.location.pathname, window.location.origin);

    url.searchParams.set('section_id', sectionId);

    if (optionValueIds && optionValueIds.length) {
      url.searchParams.set('option_values', optionValueIds.join(','));
    } else {
      url.searchParams.delete('option_values');
    }

    return url.toString();
  }

  function syncDataAttributes(target, source) {
    if (!target || !source) return;

    Array.prototype.slice.call(target.attributes).forEach(function (attribute) {
      if (attribute && attribute.name && attribute.name.indexOf('data-') === 0) {
        target.removeAttribute(attribute.name);
      }
    });

    Array.prototype.slice.call(source.attributes).forEach(function (attribute) {
      if (attribute && attribute.name && attribute.name.indexOf('data-') === 0) {
        target.setAttribute(attribute.name, attribute.value);
      }
    });
  }

  function replaceInnerHTML(currentElement, nextElement) {
    if (!currentElement || !nextElement) return;

    currentElement.innerHTML = nextElement.innerHTML;
  }

  function patchChoiceButton(currentButton, nextButton) {
    if (!currentButton || !nextButton) return;

    currentButton.className = nextButton.className;
    currentButton.disabled = nextButton.disabled;

    syncDataAttributes(currentButton, nextButton);

    var ariaPressed = nextButton.getAttribute('aria-pressed');
    if (ariaPressed != null) {
      currentButton.setAttribute('aria-pressed', ariaPressed);
    } else {
      currentButton.removeAttribute('aria-pressed');
    }
  }

  function patchChoiceGroup(currentGroup, nextGroup) {
    if (!currentGroup || !nextGroup) return false;

    var currentButtons = queryAll(currentGroup, '[data-option-value-id]');
    var nextButtons = queryAll(nextGroup, '[data-option-value-id]');

    if (!currentButtons.length || currentButtons.length !== nextButtons.length) {
      return false;
    }

    var isPatchable = currentButtons.every(function (button, index) {
      return String(button.getAttribute('data-option-value-id') || '') === String(nextButtons[index].getAttribute('data-option-value-id') || '');
    });

    if (!isPatchable) {
      return false;
    }

    currentButtons.forEach(function (currentButton, index) {
      patchChoiceButton(currentButton, nextButtons[index]);
    });

    return true;
  }

  function replaceWizardFragments(root, nextRoot) {
    var currentProductId = String(root.getAttribute('data-product-id') || '');
    var nextProductId = String(nextRoot.getAttribute('data-product-id') || '');
    var productChanged = currentProductId && nextProductId ? currentProductId !== nextProductId : true;

    var currentGallery = query(root, '[data-gallery]');
    var nextGallery = query(nextRoot, '[data-gallery]');
    if (productChanged && currentGallery && nextGallery) {
      replaceInnerHTML(currentGallery, nextGallery);
    }

    var currentStepper = query(root, '[data-people-stepper]');
    var nextStepper = query(nextRoot, '[data-people-stepper]');
    if (currentStepper && nextStepper) {
      if (productChanged) {
        syncDataAttributes(currentStepper, nextStepper);
        replaceInnerHTML(currentStepper, nextStepper);
      } else {
        syncDataAttributes(currentStepper, nextStepper);
      }
    }

    ['size', 'frame'].forEach(function (groupName) {
      var currentGroup = query(root, '[data-option-group="' + groupName + '"]');
      var nextGroup = query(nextRoot, '[data-option-group="' + groupName + '"]');

      if (currentGroup && nextGroup) {
        if (!productChanged && patchChoiceGroup(currentGroup, nextGroup)) {
          return;
        }

        replaceInnerHTML(currentGroup, nextGroup);
      }
    });

    if (productChanged) {
      var currentTitle = query(root, '.memorial-wizard-v5__title');
      var nextTitle = query(nextRoot, '.memorial-wizard-v5__title');
      if (currentTitle && nextTitle) {
        currentTitle.textContent = nextTitle.textContent;
      }

      var currentEyebrow = query(root, '.memorial-wizard-v5__eyebrow');
      var nextEyebrow = query(nextRoot, '.memorial-wizard-v5__eyebrow');
      if (currentEyebrow && nextEyebrow) {
        currentEyebrow.textContent = nextEyebrow.textContent;
      }

      var currentReviewSummary = query(root, '[data-review-summary]');
      var nextReviewSummary = query(nextRoot, '[data-review-summary]');
      if (currentReviewSummary && nextReviewSummary && currentReviewSummary.parentNode) {
        currentReviewSummary.parentNode.replaceChild(nextReviewSummary.cloneNode(true), currentReviewSummary);
      } else if (!currentReviewSummary && nextReviewSummary) {
        var currentPriceRow = query(root, '.memorial-wizard-v5__price-row');
        if (currentPriceRow && currentPriceRow.parentNode) {
          currentPriceRow.parentNode.insertBefore(nextReviewSummary.cloneNode(true), currentPriceRow);
        }
      } else if (currentReviewSummary && !nextReviewSummary && currentReviewSummary.parentNode) {
        currentReviewSummary.parentNode.removeChild(currentReviewSummary);
      }
    }
  }

  function replaceConfigScript(root, nextRoot) {
    var currentScript = query(root, '[data-memorial-wizard-v7-config]');
    var nextScript = query(nextRoot, '[data-memorial-wizard-v7-config]');

    if (currentScript && nextScript) {
      currentScript.textContent = nextScript.textContent;
    }
  }

  function setLoading(root, isLoading) {
    root.classList.toggle('is-loading', isLoading);
    root.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function getSelectionResponseCache(root) {
    if (!root.__mw5ResponseCache) {
      root.__mw5ResponseCache = {
        map: {},
        order: []
      };
    }

    return root.__mw5ResponseCache;
  }

  function getCachedSelectionResponse(root, cacheKey) {
    var cache = getSelectionResponseCache(root);
    return cache.map[cacheKey] || null;
  }

  function cacheSelectionResponse(root, cacheKey, responseText) {
    var cache = getSelectionResponseCache(root);

    if (!cache.map[cacheKey]) {
      cache.order.push(cacheKey);
    }

    cache.map[cacheKey] = responseText;

    while (cache.order.length > 30) {
      var oldestKey = cache.order.shift();
      if (oldestKey && oldestKey !== cacheKey) {
        delete cache.map[oldestKey];
      }
    }
  }

  function clearCachedSelectionResponse(root, cacheKey) {
    var cache = getSelectionResponseCache(root);
    delete cache.map[cacheKey];
    cache.order = cache.order.filter(function (key) {
      return key !== cacheKey;
    });
  }

  function focusAfterUpdate(root, focusMeta) {
    if (!focusMeta) return;

    if (focusMeta.type === 'choice' && focusMeta.optionValueId) {
      var optionButton = query(root, '[data-option-value-id="' + focusMeta.optionValueId + '"]');
      if (optionButton && typeof optionButton.focus === 'function') {
        optionButton.focus();
      }
      return;
    }

    if (focusMeta.type === 'stepper' && focusMeta.direction) {
      var stepperButton = query(root, '[data-stepper-dir="' + focusMeta.direction + '"]');
      if (stepperButton && typeof stepperButton.focus === 'function') {
        stepperButton.focus();
      }
    }
  }

  function applyResponseText(root, config, responseText, focusMeta, requestId) {
    if (requestId !== undefined && requestId !== root.__mw5RequestId) return;

    var html = new DOMParser().parseFromString(responseText, 'text/html');
    var nextRoot = query(html, '[data-memorial-wizard-v7]');
    var nextConfig = nextRoot ? parseConfig(nextRoot) : null;

    if (!nextRoot || !nextConfig) {
      throw new Error('Unable to parse updated wizard state');
    }

    replaceWizardFragments(root, nextRoot);
    replaceConfigScript(root, nextRoot);

    if (nextRoot.getAttribute('data-product-url')) {
      root.setAttribute('data-product-url', nextRoot.getAttribute('data-product-url'));
    }

    if (nextRoot.getAttribute('data-product-id')) {
      root.setAttribute('data-product-id', nextRoot.getAttribute('data-product-id'));
    }

    if (nextRoot.getAttribute('data-section-id')) {
      root.setAttribute('data-section-id', nextRoot.getAttribute('data-section-id'));
    }

    Object.keys(config).forEach(function (key) {
      delete config[key];
    });
    Object.assign(config, nextConfig);

    var updatedState = readSelectedState(root);
    updateSummary(root, updatedState, config);
    updatePeopleStepper(root, config);
    updateVariantDisplay(root, config);
    focusAfterUpdate(root, focusMeta);
  }

  function refreshSelection(root, config, selection, focusMeta) {
    if (!selection || !selection.optionPosition || !selection.optionValueId) return;

    var state = readSelectedState(root);
    var currentProductUrl = root.getAttribute('data-product-url') || config.productUrl || window.location.pathname;
    var currentOptionValueId = state.byPosition[String(selection.optionPosition)] || '';
    var productUrl = selection.productUrl || currentProductUrl;

    if (String(currentOptionValueId) === String(selection.optionValueId) && String(productUrl) === String(currentProductUrl)) {
      return;
    }

    if (selection.optionName) {
      state.byName[selection.optionName] = selection.optionValueName || '';
    }
    state.byPosition[String(selection.optionPosition)] = String(selection.optionValueId);

    var optionValueIds = selectedOptionValueIds(state);
    var cacheKey = buildSelectionCacheKey(productUrl, optionValueIds);

    var requestId = Number(root.__mw5RequestId || 0) + 1;
    root.__mw5RequestId = requestId;

    if (root.__mw5AbortController && typeof root.__mw5AbortController.abort === 'function') {
      try { root.__mw5AbortController.abort(); } catch (error) {}
    }

    root.__mw5AbortController = typeof AbortController === 'function' ? new AbortController() : null;

    applyOptimisticSelection(root, config, selection);

    var cachedResponse = getCachedSelectionResponse(root, cacheKey);
    if (cachedResponse) {
      try {
        applyResponseText(root, config, cachedResponse, focusMeta, requestId);
        setLoading(root, false);
        return;
      } catch (error) {
        clearCachedSelectionResponse(root, cacheKey);
        console.error('Memorial wizard v7 cached option refresh failed', error);
      }
    }

    setLoading(root, true);

    fetch(buildSectionUrl(
      productUrl,
      root.getAttribute('data-section-id') || config.sectionId,
      optionValueIds
    ), {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: root.__mw5AbortController ? root.__mw5AbortController.signal : undefined
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to update product options');
      }
      return response.text();
    }).then(function (responseText) {
      if (requestId !== root.__mw5RequestId) return;

      cacheSelectionResponse(root, cacheKey, responseText);
      applyResponseText(root, config, responseText, focusMeta, requestId);
    }).catch(function (error) {
      if (error && error.name === 'AbortError') return;

      console.error('Memorial wizard v7 option refresh failed', error);

      var statusEl = query(root, '[data-wizard-status]');
      if (statusEl) {
        statusEl.textContent = 'We couldn’t update this option right now. Please try again.';
      }
    }).finally(function () {
      if (requestId === root.__mw5RequestId) {
        setLoading(root, false);
      }
    });
  }

  function initWizard(root) {
    var config = parseConfig(root);
    if (!config) return;

    var currentStep = 0;
    var maxStep = stepCount(root) - 1;

    function logDebug(label, data) {
      if (window && window.console && typeof window.console.log === 'function') {
        try { window.console.log('[Memorial wizard v7] ' + label, data); } catch (e) {}
      }
    }

    // Delegated click handler — covers option buttons, the people stepper, and the
    // step-navigation buttons (Next / Back / progress jump). Bound on the wizard root so it
    // survives any DOM mutations from upload apps (Globo Product Options) or our own variant-
    // refresh logic. Direct per-button listeners go stale when those apps replace markup,
    // which causes the intermittent "Next button doesn't work" issue.
    root.addEventListener('click', function (event) {
      // Option choice buttons (size, frame)
      var optionButton = event.target.closest('[data-option-name][data-option-value-id]');
      if (optionButton && root.contains(optionButton)) {
        if (optionButton.disabled) return;

        event.preventDefault();

        refreshSelection(root, config, {
          optionName: optionButton.getAttribute('data-option-name'),
          optionValueName: optionButton.getAttribute('data-option-value'),
          optionValueId: optionButton.getAttribute('data-option-value-id'),
          optionPosition: optionButton.getAttribute('data-option-position'),
          productUrl: optionButton.getAttribute('data-product-url')
        }, {
          type: 'choice',
          optionValueId: optionButton.getAttribute('data-option-value-id')
        });

        return;
      }

      // People stepper +/- buttons
      var stepperButton = event.target.closest('[data-stepper-dir]');
      if (stepperButton && root.contains(stepperButton)) {
        if (stepperButton.disabled) return;

        var stepper = query(root, '[data-people-stepper]');
        if (!stepper) return;

        event.preventDefault();

        refreshSelection(root, config, {
          optionName: stepper.getAttribute('data-option-name'),
          optionValueName: stepperButton.getAttribute('data-stepper-target-value'),
          optionValueId: stepperButton.getAttribute('data-stepper-target-value-id'),
          optionPosition: stepper.getAttribute('data-option-position'),
          productUrl: stepperButton.getAttribute('data-product-url') || root.getAttribute('data-product-url')
        }, {
          type: 'stepper',
          direction: stepperButton.getAttribute('data-stepper-dir')
        });

        return;
      }

      // Step navigation: Next
      var nextBtn = event.target.closest('[data-next-step]');
      if (nextBtn && root.contains(nextBtn)) {
        if (nextBtn.disabled) return;
        currentStep = Math.min(currentStep + 1, maxStep);
        setProgress(root, currentStep);
        scrollToWizardTop();
        return;
      }

      // Step navigation: Back
      var prevBtn = event.target.closest('[data-prev-step]');
      if (prevBtn && root.contains(prevBtn)) {
        if (prevBtn.disabled) return;
        currentStep = Math.max(currentStep - 1, 0);
        setProgress(root, currentStep);
        scrollToWizardTop();
        return;
      }

      // Step navigation: jump (progress nav buttons)
      var goBtn = event.target.closest('[data-go-step]');
      if (goBtn && root.contains(goBtn)) {
        if (goBtn.disabled) return;
        currentStep = Math.max(0, Math.min(maxStep, Number(goBtn.getAttribute('data-go-step')) || 0));
        setProgress(root, currentStep);
        scrollToWizardTop();
        return;
      }
    });

    function scrollToWizardTop() {
      setTimeout(function() {
        var target = root.querySelector('.memorial-wizard-v5__panel') || root;
        var offset = 20;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 50);
    }

    // ---- Add-immediately upsell sync ----
    // The artist upsell goes to the cart the moment the customer ticks the checkbox, and is
    // removed when they untick. By the time they click Add to cart for the main portrait, the
    // artist line is already in the cart. Whatever flow the apps run on the click (Globo,
    // Customily, CandyRack, etc.) only handles the main portrait — they don't need to
    // cooperate with our upsell logic. Sidesteps every click/submit/fetch interception issue.
    //
    // Wizard-managed line items are tagged with `_wizard_managed: 'true'` so we can find and
    // remove them later (when the customer changes their mind, or to clean up orphaned items
    // from a previous abandoned wizard session on next page load).
    var upsellSyncTimer = null;
    var upsellSyncInFlight = null;

    function buildUpsellItems() {
      var items = [];
      var artistCheckbox = query(root, '[data-artist-upsell-checkbox]');
      if (artistCheckbox && artistCheckbox.checked && config.artist && config.artist.variantId) {
        items.push({
          id: Number(config.artist.variantId),
          quantity: 1,
          properties: { '_Artist upgrade': config.artist.summaryTitle || config.artist.title || 'Top-rated artist' }
        });
      }
      return items;
    }

    function annotateWizardManaged(items) {
      var out = [];
      for (var i = 0; i < items.length; i++) {
        var src = items[i];
        var clone = { id: src.id, quantity: src.quantity, properties: {} };
        if (src.properties) {
          for (var k in src.properties) {
            if (Object.prototype.hasOwnProperty.call(src.properties, k)) {
              clone.properties[k] = src.properties[k];
            }
          }
        }
        clone.properties._wizard_managed = 'true';
        out.push(clone);
      }
      return out;
    }

    function isWizardManagedLine(line) {
      return !!(line && line.properties && (line.properties._wizard_managed === 'true' || line.properties._wizard_managed === true));
    }

    function syncUpsells() {
      var desiredItems = annotateWizardManaged(buildUpsellItems());

      if (upsellSyncInFlight) {
        return upsellSyncInFlight.then(function () { return syncUpsells(); });
      }

      upsellSyncInFlight = fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('cart.js failed (status ' + response.status + ')');
        return response.json();
      }).then(function (cart) {
        var existingWizardLines = (cart.items || []).filter(isWizardManagedLine);
        logDebug('syncUpsells: current state', {
          cartItemCount: (cart.items || []).length,
          existingWizardLines: existingWizardLines.length,
          desiredItems: desiredItems.length
        });

        var chain = Promise.resolve();
        existingWizardLines.forEach(function (line) {
          chain = chain.then(function () {
            return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          });
        });
        return chain;
      }).then(function () {
        if (desiredItems.length === 0) {
          logDebug('syncUpsells: no items to add', null);
          return null;
        }
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: desiredItems })
        }).then(function (response) {
          if (!response.ok) {
            return response.text().then(function (text) {
              logDebug('syncUpsells: cart/add FAILED', { status: response.status, body: text.substring(0, 400) });
              throw new Error('cart/add failed (status ' + response.status + ')');
            });
          }
          return response.json();
        });
      }).then(function () {
        logDebug('syncUpsells: complete', { items: desiredItems });
      }).catch(function (error) {
        logDebug('syncUpsells: error', { error: error, message: error && error.message });
      }).then(function () {
        upsellSyncInFlight = null;
      });

      return upsellSyncInFlight;
    }

    function scheduleUpsellSync() {
      if (upsellSyncTimer) clearTimeout(upsellSyncTimer);
      upsellSyncTimer = setTimeout(syncUpsells, 350);
    }

    // Initial sync clears any orphaned wizard items from a previously abandoned session
    scheduleUpsellSync();

    var artistCheckbox = query(root, '[data-artist-upsell-checkbox]');
    if (artistCheckbox) {
      artistCheckbox.addEventListener('change', function () {
        updateVariantDisplay(root, config);
        scheduleUpsellSync();
      });
    }

    setProgress(root, currentStep);
    updateSummary(root, readSelectedState(root), config);
    updatePeopleStepper(root, config);
    updateVariantDisplay(root, config);

    window.addEventListener('resize', function () {
      syncGalleryVideoPlayback(root);
    });

    var galleryEl = query(root, '[data-gallery]');
    if (galleryEl) {
      galleryEl.addEventListener('scroll', function () {
        syncGalleryVideoPlayback(root);
      }, { passive: true });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        queryAll(root, '[data-gallery-media-id] video').forEach(function (video) {
          try { video.pause(); } catch (e) {}
        });
      } else {
        syncGalleryVideoPlayback(root);
      }
    });

    window.addEventListener('pageshow', function () {
      syncGalleryVideoPlayback(root);
    });

    ['click', 'touchstart', 'keydown'].forEach(function (eventName) {
      document.addEventListener(eventName, function retryAutoplayOnce() {
        syncGalleryVideoPlayback(root);
      }, { once: true, passive: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    queryAll(document, '[data-memorial-wizard-v7]').forEach(initWizard);
  });
})();
